module.exports = __webpack_public_path__ + "static/media/Kamel-min.27fb295c.PNG";